import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import colors from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';
import ChevronDown from 'svg/ChevronDown';

type ExpandableAreaProps = {
  children: React.ReactNode;
  // Drop the interior horizontal/bottom padding in mobile so the expanded content can sit flush.
  mobileFlush?: boolean;
};

function ExpandableArea({ children, mobileFlush = false }: ExpandableAreaProps) {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <Container>
      {expanded && <InteriorContainer $mobileFlush={mobileFlush}>{children}</InteriorContainer>}
      <ExpandableHandle onClick={toggleExpanded}>
        <ChevronIcon $expanded={expanded} />
        <StyledText>{expanded ? 'Collapse' : 'Expand'}</StyledText>
      </ExpandableHandle>
    </Container>
  );
}

const StyledText = styled(BodySmall)`
  color: ${colors.blue100};
`;

const ChevronIcon = styled(ChevronDown)<{ $expanded: boolean }>`
  transform: ${({ $expanded }) => ($expanded ? 'rotate(0deg)' : 'rotate(180deg)')};
  transform-origin: center;
`;

const Container = styled.div`
  width: 100%;
`;

const InteriorContainer = styled.div<{ $mobileFlush?: boolean }>`
  padding: 0 24px 24px;

  ${({ $mobileFlush }) =>
    $mobileFlush &&
    css`
      @media (max-width: 800px) {
        padding: 0;
      }
    `}
`;

const ExpandableHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 18px;
  cursor: pointer;
  border-top: 1px solid var(--black-15);
`;

export default ExpandableArea;
